import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { ColorPickerModule } from '../color-picker';
import { ExpressionEditorModule } from '../expression-editor';
import { InputExpressionModule } from '../input-expression';
import { SlideBarModule } from '../slide-bar';
import { PropertyBagComponent, PropertyGroupComponent } from './property-bag.component';
import { PropertyCheckboxComponent } from './property-checkbox/property-checkbox.component';
import { PropertyClassificationComponent } from './property-classification';
import { PropertyColorComponent } from './property-color/property-color.component';
import { PropertyExpressionComponent } from './property-expression/property-expression.component';
import { PropertyNumberComponent } from './property-number/property-number.component';
import { PropertyPointArrayComponent } from './property-point-array/property-point-array.component';
import { PropertyPointComponent } from './property-point/property-point.component';
import { PropertySelectComponent } from './property-select/property-select.component';
import { PropertySwitchComponent } from './property-switch/property-switch.component';
import { PropertyTextComponent } from './property-text/property-text.component';
import { PropertyToggleComponent } from './property-toggle/property-toggle.component';

@NgModule({
    declarations: [
        PropertyBagComponent,
        PropertyColorComponent,
        PropertyCheckboxComponent,
        PropertyToggleComponent,
        PropertyNumberComponent,
        PropertySelectComponent,
        PropertyGroupComponent,
        PropertyTextComponent,
        PropertyPointComponent,
        PropertyExpressionComponent,
        PropertyPointArrayComponent,
        PropertySwitchComponent,
        PropertyClassificationComponent,
    ],
    imports: [
        TwcModule,
        CommonModule,
        TranslateModule,
        ColorPickerModule,
        SlideBarModule,
        FormsModule,
        ExpressionEditorModule,
        InputExpressionModule,
        DirectivesModule,
    ],
    exports: [PropertyBagComponent],
})
export class PropertyBagModule {}
